import classNames from 'classnames';

const BASE = 'pointer-events-none absolute h-0 w-0 border-solid border-transparent';

export function ChartTooltipArrow({
  side,
  variant = 'dark', // 'dark' | 'white'
}) {
  const isWhite = variant === 'white';

  // pick which border side is "pointing" out of the tooltip
  const fillSide =
    side === 'top'
      ? 'border-t-white'
      : side === 'bottom'
        ? 'border-b-white'
        : side === 'left'
          ? 'border-l-white'
          : side === 'right'
            ? 'border-r-white'
            : null;

  const darkSide =
    side === 'top'
      ? 'border-t-woodsmoke-500/90'
      : side === 'bottom'
        ? 'border-b-woodsmoke-500/90'
        : side === 'left'
          ? 'border-l-woodsmoke-500/90'
          : side === 'right'
            ? 'border-r-woodsmoke-500/90'
            : null;

  const outlineSide =
    side === 'top'
      ? 'border-t-mystic-500'
      : side === 'bottom'
        ? 'border-b-mystic-500'
        : side === 'left'
          ? 'border-l-mystic-500'
          : side === 'right'
            ? 'border-r-mystic-500'
            : null;

  if (!fillSide || !outlineSide) return null;

  const outlineCls = classNames(BASE, 'border-[6px]', outlineSide);
  const fillCls = classNames(BASE, 'border-[5px]', isWhite ? fillSide : darkSide);

  const outlineStyle = {};
  const fillStyle = {};

  // NOTE: outline stays flush to tooltip edge, fill shifts 1px away (opposite direction)
  if (side === 'top') {
    Object.assign(outlineStyle, { left: '50%', bottom: 0, transform: 'translate(-50%, 100%)' });
    Object.assign(fillStyle, { left: '50%', bottom: 1, transform: 'translate(-50%, 100%)' });
  } else if (side === 'bottom') {
    Object.assign(outlineStyle, { left: '50%', top: 0, transform: 'translate(-50%, -100%)' });
    Object.assign(fillStyle, { left: '50%', top: 1, transform: 'translate(-50%, -100%)' });
  } else if (side === 'left') {
    Object.assign(outlineStyle, { right: 0, top: '50%', transform: 'translate(100%, -50%)' });
    Object.assign(fillStyle, { right: 1, top: '50%', transform: 'translate(100%, -50%)' });
  } else if (side === 'right') {
    Object.assign(outlineStyle, { left: 0, top: '50%', transform: 'translate(-100%, -50%)' });
    Object.assign(fillStyle, { left: 1, top: '50%', transform: 'translate(-100%, -50%)' });
  }

  return (
    <>
      {isWhite && <div className={outlineCls} style={outlineStyle} />}
      <div className={fillCls} style={fillStyle} />
    </>
  );
}
